import {
    SET_USER,
    GET_USER,
    SET_LABELS,
    SET_OPTIONS,
    SET_PER_PAGE,
    SET_SORT_TYPE,
    SET_TAB_INDEX,
    SET_PAGE_NUMBER,
    SET_MEMBER_DIALOG,
    SET_NEW_MESSAGE_DIALOG,
    SET_FILE_MANAGER_DIALOG
} from "redux/types";

const tabLabelsFromStorage = localStorage.hasOwnProperty('tabs')
    ? JSON.parse(localStorage.getItem('tabs'))
    : [];

const directoryLabelsFromStorage = localStorage.hasOwnProperty('directory')
    ? JSON.parse(localStorage.getItem('directory'))
    : [];

const INITIAL_STATE = {
    sort: '',
    theme: null,
    tabIndex: 0,
    logAccess: [],
    pageNumber: 1,
    pageLimit: 20,
    paidUser: false,
    drawerOpen: false,
    memberDialog: false,
    composeDialog: false,
    member_type: 'Basic',
    title: 'Message Center',
    fileManagerDialog: false,
    tabs: tabLabelsFromStorage,
    directory: directoryLabelsFromStorage
}

export const inboxReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_USER:
            return {
                ...state,
                ...action.payload
            }
        case SET_NEW_MESSAGE_DIALOG:
            return {
                ...state,
                composeDialog: action.payload
            }
        case SET_MEMBER_DIALOG:
            return {
                ...state,
                memberDialog: action.payload
            }
        case SET_TAB_INDEX:
            return {
                ...state,
                tabIndex: action.payload
            }
        case SET_SORT_TYPE:
            return {
                ...state,
                sort: action.payload
            };
        case SET_PER_PAGE:
            return {
                ...state,
                pageLimit: action.payload
            };
        case SET_PAGE_NUMBER:
            return {
                ...state,
                pageNumber: action.payload
            };
        case SET_OPTIONS:
            return {
                ...state,
                ...action.payload
            }
        case SET_LABELS:
            return {
                ...state,
                ...action.payload
            }
        case SET_FILE_MANAGER_DIALOG:
            return {
                ...state,
                fileManagerDialog: action.payload
            }
        case SET_USER:
            return {
                ...state,
                user: action.payload
            }
        default:
            return state;
    }
};
